'use strict';

var FaresOptimizerChartsDirective = function FaresOptimizerChartsDirective() {
  return {
    restrict: 'E',
    replace: true,
    controller: 'FaresOptimizerChartsController',
    template: require('../templates/fares-optimizer-charts.html'),
    scope: {
      screenState: '=',
      settings: '=',
      renderDateChart: '=',
      renderFareChart: '=',
      renderWebFareChart: '=',
      isBenchmarkView: '=',
      chartData: '='
    }
  };
};
FaresOptimizerChartsDirective.$inject = ['$timeout'];
module.exports = FaresOptimizerChartsDirective;